const isfunction = (value) => typeof value === 'function'
const isUndefined = (value) => typeof value === 'undefined'

export { isfunction as default, isfunction, isUndefined }